import { Button, InputAdornment, ListItemText, Stack, TextField, } from '@mui/material';
import { useTheme } from '@mui/system';
import React, { useState } from 'react';
import { useGenerateLinkMutation } from '../../../api/apiSlice';
import CopyButton from '../../CustomComponents/CopyButton';

function PhysicianLink(props) {
    const theme = useTheme();
    const [generatedLink, setGeneratedLink] = useState();

    const [generateLink] = useGenerateLinkMutation();

    async function handleGenerateLink() {
        await generateLink({
            cardOwner: [props.physician.id],
            campaign: props.campaignId

        }).unwrap().then((payload) => {
            setGeneratedLink(payload);
        });
    }

    return (
        <Stack p={1} spacing={3} direction='row' alignItems='center' sx={{ maxWidth: '60%', backgroundColor: `${theme.palette.background.main}`, borderRadius: '8px' }}>
            <ListItemText primary={`Dr. ${props.physician.last_name}, ${props.physician.first_name}`} style={{ width: '25%' }} />
            <TextField 
                variant='standard'
                value={generatedLink}
                size='small'
                InputProps={{
                    readOnly: true,
                    startAdornment: (
                        <InputAdornment position='start'>
                            <CopyButton textToCopy={generatedLink} size='medium' fontSize='16px' />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position='end'>
                            <Button variant='text' onClick={handleGenerateLink}>
                                Generate Link
                            </Button>
                        </InputAdornment>
                    )
                }}
            />
        </Stack>
    )
}

export default PhysicianLink;
